import { atom, getDefaultStore } from 'jotai';
import { detectBrowserLanguage, readUserSelectedLanguage } from '@/lib/langPreference';

// In-memory active language. A visitor's own choice is stored separately
// (localStorage `lang` and cookie `pp_lang`) and is read by readUserSelectedLanguage.
// Writing this atom must not persist a choice — applyLanguage does that only
// when the visitor picks a language in the switcher.
export const currentLangAtom = atom(readUserSelectedLanguage() ?? detectBrowserLanguage());

/** Header / non-React language: saved choice, otherwise the active in-memory code. */
export function getActiveLanguage(): string {
  return readUserSelectedLanguage() ?? getDefaultStore().get(currentLangAtom);
}
